import { render, staticRenderFns } from "./student-detail-page.html?vue&type=template&id=0855afa9&"
import script from "./student-detail-page.ts?vue&type=script&lang=ts&"
export * from "./student-detail-page.ts?vue&type=script&lang=ts&"
import style0 from "./student-detail-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports